import { Component } from '@angular/core';
import { CommonComponent } from '@components/common.component';
import { AnnouncementsDashboardComponent } from '@announcements/components/announcements-dashboard/announcements-dashboard.component';
import { CalendarDashboardComponent } from '@calendar/components/calendar-dashboard/calendar-dashboard.component';
import { DiningDashboardComponent } from '@dining/components/dining-dashboard/dining-dashboard.component';
import { GalleryDashboardComponent } from '@gallery/components/gallery-dashboard/gallery-dashboard.component';
import { MessagesDashboardComponent } from '@messages/components/messages-dashboard/messages-dashboard.component';
import { WeatherComponent } from '@shared-components/weather/weather.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-family-page',
  standalone: true,
  imports: [
    AnnouncementsDashboardComponent,
    CalendarDashboardComponent,
    DiningDashboardComponent,
    GalleryDashboardComponent,
    MessagesDashboardComponent,
    WeatherComponent,
    CommonModule,
  ],
  templateUrl: './dashboard-family-page.component.html',
  styleUrl: './dashboard-family-page.component.scss',
})
export class DashboardFamilyPageComponent extends CommonComponent {
  get canMessageCommunity(): boolean {
    const isDisabled = this.community?.corporation?.flags?.some(
      (f: { name: string; value: boolean }) =>
        f.name === 'DISABLED_FAMILY_AND_RESIDENT_TO_STAFF_MESSAGING' && f.value === true,
    );

    const isResidentOrRelative = this.user?.roles?.some(
      (r: { name: string }) =>
        r.name.includes('COMMUNITY_RESIDENT') || r.name.includes('COMMUNITY_RELATIVE'),
    );

    return !(isDisabled && isResidentOrRelative);
  }
}
